"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalTitle = void 0;
const react_1 = __importDefault(require("react"));
const react_if_1 = require("react-if");
const ModalTitle = ({ children = null, onHide = null, }) => (react_1.default.createElement(react_1.default.Fragment, null,
    react_1.default.createElement(react_if_1.When, { condition: children !== null },
        react_1.default.createElement("div", { className: "modal__title" }, children)),
    react_1.default.createElement(react_if_1.When, { condition: onHide !== null },
        react_1.default.createElement("i", { role: "presentation", className: "btn-close", onClick: onHide }))));
exports.ModalTitle = ModalTitle;
